import { createActionType } from '../../helpers'

export const LOAD_FAVOURITES = createActionType('FAVOURITES', 'LOAD')
export const TOGGLE_FAVOURITE = createActionType('FAVOURITES', 'TOGGLE')
export const UPDATE_FAVOURITE_ORDER = createActionType('FAVOURITES', 'UPDATE')
